<template>
    <div id="container">
        <el-container>
            <el-header v-if="!isMobile" class="header-box" :height="'80px'">
                <el-row>
                    <el-col :xs="24" :sm="{span: 12, offset: 6}">
                        <el-row>
                            <el-col :span="12">
                                <!-- <div class="teach-logo"></div> -->
                                <div class="logo-box">
                                    <img :src="logo ? logo : teachLogo" width="44" height="44" style="border-radius: 4px;" alt="">
                                    <img src="../assets/yuanbanke@2x.png" width="130" height="40" style="margin-left: 10px;" alt="">
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div class="header-right">
                                    <!-- 如果是未登录蓝墨产品进入统一身份认证的用户，且页面访问参数 accessId 为空时，登录页面增加返回学校列表按钮 -->
                                    <a v-if="!coreapiToken && !accessId && currentScene === SCENES.SCHOOL_LOGIN" class="blue" href="javascript:void(0)" @click="goBackToSchoolList">返回学校列表</a>
                                    <div v-if="!coreapiToken && !accessId && currentScene === SCENES.SCHOOL_LOGIN" class="v-line"></div>

                                    <a v-if="!accessId" href="https://www.mosoteach.cn" class="blue">返回云班课</a>
                                    <div v-if="!accessId" class="v-line"></div>
                                    <a href="http://help.mosoteach.cn" target="_blank" class="blue">帮助</a>
                                </div>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </el-header>
            <el-main style="min-height: 700px;">
                <el-row>
                    <el-col :xs="24" :sm="{span: 12, offset: 6}" v-loading="loading">
                        <!-- The school list scene -->
                        <div v-if="currentScene === SCENES.SCHOOL_LIST">
                            <h2>请选择你的学校</h2>
                            <div class="hint">
                                目前我们只开通了部分学校的统一身份认证，后续会陆续开通其他学校的统一身份认证功能。
                            </div>
                            <div style="padding-top: 20px; padding-bottom: 20px;">
                                <el-input placeholder="输入学校名称查找" v-model="schoolListScene.form.searchText" size="fslarge">
                                    <el-button slot="append" icon="el-icon-search"></el-button>
                                </el-input>
                            </div>
                            <el-table :data="shownSchools" 
                                :show-header="false" 
                                :empty-text="loading ? '加载中...' : '很抱歉，没有找到学校 ' + schoolListScene.form.searchText"
                                size="fslarge"
                                v-on:row-click="onSchoolClick">
                                <el-table-column prop="name" ></el-table-column>
                            </el-table>
                        </div>

                        <!-- School login scene -->
                        <div v-if="currentScene === SCENES.SCHOOL_LOGIN">
                            <h3 v-if="action === 'login' || action === 'bind'">请使用你在{{ school.name }}{{ school.sysName }}的信息{{ action === 'login' ? '登录': '认证' }}</h3>
                            <h3 v-if="action === 'confirm'">请认真填写你在{{ school.name }}{{ school.sysName }}的个人信息</h3>
                            
                            <el-form :model="schoolLoginScene.form" 
                                     label-position="top" 
                                     label-width="100px" 
                                     size="fslarge">
                                <el-form-item label="身份">
                                    <el-radio-group v-model="schoolLoginScene.form.userType">
                                        <el-radio label="T" v-if="school.ssoConfig.teacherEnabled">我是老师</el-radio>
                                        <el-radio label="S" v-if="school.ssoConfig.studentEnabled">我是学生</el-radio>
                                    </el-radio-group>
                                </el-form-item>

                                <el-form-item :label="schoolLoginScene.snLabel">
                                    <el-input v-model="schoolLoginScene.form.sn" :placeholder="action === 'login' ? '登录学校系统的账号' : ''" key="sn"></el-input>
                                </el-form-item>

                                <el-form-item label="姓名" v-if="school.ssoConfig.authType === 'SN+ID'">
                                    <el-input v-model="schoolLoginScene.form.name" placeholder="请输入姓名" key="name"></el-input>
                                </el-form-item>

                                <el-form-item label="密码" v-if="school.ssoConfig.authType === 'SN+PWD'">
                                    <el-input v-model="schoolLoginScene.form.password" :placeholder="action === 'login' ? '登录学校系统的密码' : ''" show-password key="password"></el-input>
                                </el-form-item>

                                <el-form-item label="身份证后 6 位" v-if="school.ssoConfig.authType === 'SN+ID'">
                                    <el-input v-model="schoolLoginScene.form.idNumber" placeholder="请输入身份证后 6 位" maxlength="6" show-password key="idNumber"></el-input>
                                </el-form-item>

                                <!-- <el-form-item label="院系" v-if="schoolLoginScene.showDeptSelection">
                                    <el-select v-model="schoolLoginScene.form.departmentId" placeholder="请选择蓝墨系统中的院系" size="fslarge" style="width: 100%;">
                                        <el-option v-for="d in departments"
                                            :key="d.id"
                                            :value="d.id"
                                            :label="d.name">
                                        </el-option>
                                    </el-select>
                                </el-form-item>    -->
                                <!-- <el-form-item> -->
                                    <!-- 阿里云智能人机验证容器 -->
                                    <!-- <div id="aliyun-ic"></div> -->
                                <!-- </el-form-item> -->

                                <el-form-item>
                                    <el-button type="primary" style="width: 100%;" 
                                        v-loading="schoolLoginScene.submitting" 
                                        @click="openAliyunIcDialog"
                                        :disabled="! schoolLoginScene.formValidated">
                                        {{ action === 'login' ? '登录' : action === 'bind' ? '认证' : '确认' }}
                                    </el-button>
                                </el-form-item>
                            </el-form>
                        </div>

                        <!-- The mosoink login scene -->
                        <div v-if="currentScene === SCENES.MOSOINK_LOGIN">
                            <h3 v-if="!schoolLoginScene.showDeptSelection">请输入手机号完成账号绑定</h3>
                            <h3 v-if="schoolLoginScene.showDeptSelection">请完善核对个人信息</h3>
                            <el-form :model="mosoinkLoginScene.form" label-position="top" size="fslarge">

                                <el-form-item label="姓名" v-if="schoolLoginScene.showUserNameInput">
                                    <el-input v-model="schoolLoginScene.form.userName" placeholder="请输入姓名" key="userName"></el-input>
                                </el-form-item>

                                <el-form-item label="院系" v-if="schoolLoginScene.showDeptSelection">
                                    <el-select v-model="schoolLoginScene.form.departmentId" placeholder="请选择蓝墨系统中的院系" :popper-append-to-body="false" size="fslarge" style="width: 100%;" @change="handleChange">
                                        <el-option v-for="d in departments"
                                            :key="d.id"
                                            :value="d.id"
                                            :label="d.name">
                                        </el-option>
                                    </el-select>
                                </el-form-item>

                                <el-form-item label="专业" v-if="schoolLoginScene.showMajorSelection && authType === 'THIRD_SSO'">
                                    <el-select v-model="schoolLoginScene.form.majorId" placeholder="请选择蓝墨系统中的专业" :popper-append-to-body="false" size="fslarge" style="width: 100%;">
                                        <el-option v-for="d in majors"
                                            :key="d.oid"
                                            :value="d.oid"
                                            :label="d.name">
                                        </el-option>
                                    </el-select>
                                </el-form-item>

                                <el-form-item label="行政班" v-if="schoolLoginScene.showAdminClazzSelection && authType === 'THIRD_SSO'">
                                    <el-select v-model="schoolLoginScene.form.adminClazzId" placeholder="请选择蓝墨系统中的行政班" :popper-append-to-body="false" size="fslarge" style="width: 100%;">
                                        <el-option v-for="d in adminClazzes"
                                            :key="d.oid"
                                            :value="d.oid"
                                            :label="d.name">
                                        </el-option>
                                    </el-select>
                                </el-form-item>

                                <el-form-item label="入学年份" v-if="schoolLoginScene.showEnrollYearSelection">
                                    <el-select v-model="schoolLoginScene.form.enrollYear" placeholder="请选择入学年份" :popper-append-to-body="false" size="fslarge" style="width: 100%;">
                                        <el-option label="- 请选择入学年份 -" :value="-1"></el-option>
                                        <el-option
                                            v-for="ey in enrollYears"
                                            :key="ey"
                                            :value="ey"
                                            :label="ey">
                                        </el-option>
                                    </el-select>
                                </el-form-item>

                                <el-form-item label="手机号" v-if="showPhoneValidate">
                                    <el-input type="text" 
                                        v-model="mosoinkLoginScene.form.phoneNumber" 
                                        placeholder="目前仅支持中国大陆手机号" 
                                        maxLength="11" autocomplete="off"
                                        :disabled="mosoinkLoginScene.phoneNumberInputDisabled"/>
                                </el-form-item>
                                <el-form-item label="验证码" v-if="showPhoneValidate">
                                    <el-input type="text" v-model="mosoinkLoginScene.form.smsCode" placeholder="4 位数字的短信验证码">
                                        <el-button slot="append" 
                                            :disabled="mosoinkLoginScene.getSmsCodeButtonDisabled" 
                                            @click="getSmsCode">{{ mosoinkLoginScene.getSmsCodeButtonLabel }}</el-button>
                                    </el-input>
                                </el-form-item>
                                <el-form-item v-if="showPhoneValidate">
                                    <el-button type="primary" style="width: 100%;" 
                                               @click="doMosoinkLogin" 
                                               :disabled="mosoinkLoginScene.loginButtonDisabled">登录</el-button>
                                </el-form-item>
                                <el-form-item v-if="schoolLoginScene.showDeptSelection">
                                    <el-button type="primary" style="width: 100%;" 
                                               @click="doFill" 
                                               :disabled="mosoinkLoginScene.loginFillButtonDisabled">登录</el-button>
                                </el-form-item>
                            </el-form>
                        </div>

                        <!-- confirm bind scene -->
                        <div v-if="currentScene === SCENES.CONFIRM_BIND">
                            <h3>请确认</h3>
                            <div style="text-align: center;">
                                你正在将云班课账号“{{ teachUser.phoneNumber }}”绑定到{{ $route.query.schoolUser ? schoolUser.displaySchoolName : school.name }}的{{ schoolLoginScene.snLabel }}为“{{ schoolUser.sn }}”的用户，请确认操作。
                            </div>
                            <div style="margin-top: 40px;">
                                <el-form label-position="top" size="fslarge">
                                    <el-form-item>
                                        <el-button type="primary" style="width: 100%;" 
                                               @click="bind">确认绑定</el-button>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </div>

                        <!-- the final result scene -->
                        <div v-if="currentScene === SCENES.RESULT">
                            <!-- <h3>操作成功</h3>
                            <div style="text-align: center; margin-top: 20px;">
                                <i class="el-icon-success" style="color: #0bd; font-size: 5rem;"></i>
                            </div>

                            <div class="hint" style="margin-top: 20px;">登录成功，将于 {{ resultScene.count }} 秒后返回</div>

                            <div style="margin-top: 40px;">
                                <el-form label-position="top" size="fslarge">
                                    <el-form-item>
                                        <el-button type="primary" style="width: 100%;" 
                                                :disabled="returnButtonDisabled"
                                               @click="returnToApp">立即返回</el-button>
                                    </el-form-item>
                                </el-form>
                            </div> -->
                            <div style="text-align: center;margin-top: 80px;">
                                <div>
                                    <svg viewBox="0 0 1 1" xmlns="http://www.w3.org/2000/svg" width="60px" height="60px">
                                        <path d="M 0.0 0.5
                                            A 0.5 0.5 0 1 1 0.5 1.0
                                            A 0.05 0.05 0 0 1 0.5 0.9
                                            A 0.4 0.4 0 1 0 0.1 0.5
                                            A 0.05 0.05 0 0 1 0.0 0.5" stroke-width="0" fill="#0BD">
                                            <animateTransform attributeName="transform"
                                                    attributeType="XML"
                                                    type="rotate"
                                                    from="0 0.5 0.5"
                                                    to="360 0.5 0.5"
                                                    dur="1.5s"
                                                    repeatCount="indefinite"/>
                                        </path>
                                    </svg>
                                </div>
                                <label>正在跳转中...</label>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </el-main>
        </el-container>

        <el-dialog
            title="安全验证"
            :top="'28vh'"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :destroy-on-close="true"
            :modal-append-to-body="false"
            :visible.sync="dialogVisible"
            :before-close="closeAliyunIc"
            custom-class="aliyunIcDialog"
            width="460px">
            <!-- 阿里云智能人机验证容器 -->
            <div id="aliyun-ic"></div>
        </el-dialog>
    </div>
</template>

<script>
import teachLogo from '../assets/logo-teach.png'
const myStore = require('../my-store.js');
const qs = require('querystringify');
const allConfigs = require('../app-config.js');

export default {
    name: 'HomeView',
    components: {
        
    },
    data: function() {
        return {
            SCENES: {
                SCHOOL_LIST: 'school-list',
                SCHOOL_LOGIN: 'school-login',
                MOSOINK_LOGIN: 'mosoink-login',
                CONFIRM_BIND: 'confirm-bind',
                RESULT: 'result'
            },

            currentScene: '',
            action: 'login',    // 识别云班课操作 login-未登录，学校账号密码登录；bind-已登录，认证；confirm-已登录，个人信息确认
            loading: false,
            aliyunIcOk: false,
            coreapiToken: '',
            accessId: null,
            // the current selected school
            school: {
                oid: null,
                id: null,
                accessId: null,
                ssoConfig: {
                    authType: 'SN+PWD',
                    teacherEnabled: true,
                    studentEnabled: true
                }
            },
            awscConfig: {
                appkey: "FFFF00000000017AC35D",
                scene: "ic_login_h5",
            },
            awscResult: {
                sessionId: null,
                signature: null,
                token: null
            },

            stageInitialized: false,
            appInfo: {
                id: '',
                returnTo: ''
            },
            teachUser: {
                id: '',
                userType: 'T',
                phoneNumber: '',
                name: ''
            },
            schoolUser: {
                sn: '',
                name: '',
                departmentName: '',
            },
            schools: [],
            shownSchools: [],
            departments: [],
            schoolListScene: {
                loading: false,
                dataLoaded: false,
                form: {
                    searchText: '',
                }
            },
            majors: [],
            adminClazzes: [],
            schoolLoginScene: {
                form: {
                    sn: '',
                    password: '',
                    name: '',
                    idNumber: '',
                    userType: 'T',
                    departmentId: '',
                    departmentName: '',
                    enrollYear: -1,
                    majorId: '',
                    adminClazzId: '',
                    teachMajorSn: '',
                    teachAdminClazzSn: '',
                    userName: '',
                },
                showUserNameInput: false,
                showDeptSelection: false,
                showEnrollYearSelection: false,
                showMajorSelection: false,
                showAdminClazzSelection: false,
                snLabel: '工号',
                loading: true,
                formValidated: false,
            },

            mosoinkLoginScene: {
                form: {
                    phoneNumber: '',
                    smsCode: ''
                },
                phoneNumberInputDisabled: false,
                getSmsCodeButtonDisabled: true,
                getSmsCodeButtonLabel: '获取验证码',
                loginButtonDisabled: true,
                loginFillButtonDisabled: true,
                timerId: 0,
            },

            resultScene: {
                count: 5,
                timerId: 0
            },

            returnParam: '',
            state: {
                product: '',
                action: 'login',
                appId: 'MTWEB',
                returnParam: 'home',
            },
            showPhoneValidate: true,
            nextStep: '',
            user: null,
            enrollYears: [],
            schoolAccessId: '',
            authType: '',

            returnButtonDisabled: false,
            teachLogo: teachLogo,
            logo: '',

            dialogVisible: false,
        };
    },

    computed: {
        isMobile: function() {
            let platform = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
            return platform ? true : false;
        }
    },

    created: function() {
        // console.log( decodeURIComponent ());
        this.enrollYears = [];
        let minYear = 2012;
        let maxYear = new Date().getFullYear() + 2;
        for (let i = 0; i < (maxYear - minYear + 1); i++) {
            this.enrollYears.push(maxYear - i);
        }
        if (this.$route.query.state) {
            if (this.$route.query.state.product === 'PORTAL') {
                return;
            } else if (this.$route.query.state.product === 'MOSOTEACH') {
                this.stageInitialized = this.initAppInfo();
            } else {
                if (process.env.NODE_ENV === 'development') {
                    let url = 'https://dev.mbook.cc/mosoteach/index.php';
                    window.location.href = url;
                }

                if (process.env.NODE_ENV === 'production') {
                    let url = 'https://www.mosoteach.cn/web/index.php';
                    window.location.href = url;
                }
            }
        } else {
            this.stageInitialized = this.initAppInfo();
        }
    },

    mounted: function() {
        // console.log(process.env.NODE_ENV);
        // console.log(this.$route);
        // console.log(this.$route.query);
        // console.log(this.$route.query.state);
        // console.log(this.$route.query.state.product);
        let query = this.$route.query;
        if (query.currentScene) {

            if (query.schoolToken) {
                myStore.saveToken(query.schoolToken);
            } else {
                myStore.saveToken(query.state.mttoken);
            }

            this.state = query.state;
            this.action = query.state.action;
            this.schoolUser = query.schoolUser;
            this.school.oid = query.accountOid;
            this.schoolAccessId = query.acsId;
            this.authType = query.authType;
            if (query.schoolUser) {
                this.schoolLoginScene.form.departmentId = query.schoolUser.teachDepartmentId || '';
                this.schoolLoginScene.form.teachMajorSn = query.schoolUser.teachMajorSn || '';
                this.schoolLoginScene.form.teachAdminClazzSn = query.schoolUser.teachAdminClazzSn || '';
                this.schoolLoginScene.form.enrollYear = query.schoolUser.admissionYear ? query.schoolUser.admissionYear : -1;
            }

            if (query.state.product !== 'PORTAL') {
                const envConfig = allConfigs[process.env.NODE_ENV];
                if (! envConfig || ! (this.state.appId in envConfig.apps)) {
                    console.error('无法找到对应的应用配置');
                    if (process.env.NODE_ENV === 'development') {
                        let url = 'https://dev.mbook.cc/mosoteach/index.php';
                        window.location.href = url;
                    }

                    if (process.env.NODE_ENV === 'production') {
                        let url = 'https://www.mosoteach.cn/web/index.php';
                        window.location.href = url;
                    }
                    return false;
                }
                this.appInfo = envConfig.apps[this.state.appId];
            }

            this.getSchoolConfig();

            this.currentScene = query.currentScene;
            this.nextStep = query.currentScene;
            // const phoneRegex = /^1\d{10}$/;
            switch (this.currentScene) {
                case 'RETURN_TO_PORTAL':
                    this.gotoPortal();
                    break;
                case 'RETURN_TO_APP':
                    this.gotoResult();
                    break;
                case 'CHOOSE_DEPT':
                    // this.showError('你的教务资料不是教学院系，请确定你的教学院系');
                    // this.loadDepartments();
                    // this.resetAliyunIc();
                    // this.schoolLoginScene.formValidated = false;
                    // if (query.schoolUser.admissionYear < 2012 && query.schoolUser.userType === 'S') {
                    if (query.schoolUser.userType === 'S') {
                        this.schoolLoginScene.showDeptSelection = true;
                        this.schoolLoginScene.showMajorSelection = true;
                        this.schoolLoginScene.showAdminClazzSelection = true;
                        this.schoolLoginScene.showEnrollYearSelection = true;
                        // this.getMajors(query.accountOid);
                        // this.getAdminClazzes(query.accountOid);
                        this.schoolLoginScene.form.teachMajorSn = query.schoolUser.teachMajorSn || '';
                        this.schoolLoginScene.form.teachAdminClazzSn = query.schoolUser.teachAdminClazzSn || '';
                        this.schoolLoginScene.form.enrollYear = query.schoolUser.admissionYear ? query.schoolUser.admissionYear : -1;
                    }
                    this.schoolLoginScene.showUserNameInput = true;
                    this.schoolLoginScene.form.userName = query.schoolUser.userName || '';
                    this.loadDepartments(query.accountOid);
                    this.schoolLoginScene.form.departmentId = query.schoolUser.teachDepartmentId;
                    this.showPhoneValidate = false;
                    // console.log(query);
                    this.gotoMosoinkLogin();
                    break;
                case 'LOGIN_TO_MOSOINK':
                    // // 如果手机号合法，赋值到页面
                    // if (query.schoolUser.phoneNumber && phoneRegex.test(query.schoolUser.phoneNumber)) {
                    //   this.mosoinkLoginScene.phoneNumber = query.schoolUser.phoneNumber;
                    // }
                    this.gotoMosoinkLogin();
                    break;
                case 'BIND':
                    this.teachUser.phoneNumber = query.schoolUser.phoneNumber;
                    this.schoolLoginScene.snLabel = query.schoolUser.userType === 'T' ? '教师' : '学生';
                    this.schoolUser.sn = query.schoolUser.userName;
                    this.gotoConfirmBind();
                    break;
                default:
                    console.error('未找到此类型');
                    break;
            }
        }
        if (! this.stageInitialized) {
            return;
        }

    },

    watch: {
        'schoolListScene.form.searchText': function(val) {
            this.shownSchools = this.schools.filter(s => this.schoolListScene.form.searchText.trim().length == 0 
                || (s.name && s.name.indexOf(this.schoolListScene.form.searchText.trim()) >= 0 
                    || s.cnSpell && s.cnSpell.indexOf(this.schoolListScene.form.searchText.trim()) >= 0));
        },

        'schoolLoginScene.form.userType': function(val) {
            if (val === 'T') {
                this.schoolLoginScene.snLabel = '工号';
            } else {
                this.schoolLoginScene.snLabel = '学号';
            }
        },

        'schoolLoginScene.form.sn': function(val) {
            this.validateSchoolLoginForm();
        },

        'schoolLoginScene.form.name': function(val) {
            this.validateSchoolLoginForm();  
        },

        'schoolLoginScene.form.password': function(val) {
            this.validateSchoolLoginForm();
        },

        'schoolLoginScene.form.idNumber': function(val) {
            this.validateSchoolLoginForm();
        },

        'schoolLoginScene.form.departmentId': function(val) {
            this.schoolLoginScene.form.majorId = '';
            this.schoolLoginScene.form.adminClazzId = '';
            this.validateMosoinkLoginForm();
            this.getMajors();
        },

        'schoolLoginScene.form.majorId': function(val) {
            this.schoolLoginScene.form.adminClazzId = '';
            this.validateMosoinkLoginForm();
            this.getAdminClazzes();
        },

        'schoolLoginScene.form.adminClazzId': function(val) {
            this.validateMosoinkLoginForm();
        },

        'schoolLoginScene.form.enrollYear': function(val) {
            this.validateMosoinkLoginForm();
        },

        'mosoinkLoginScene.form.phoneNumber': function(val) {
            this.validateMosoinkLoginForm();
        },

        'mosoinkLoginScene.form.smsCode': function(val) {
            this.validateMosoinkLoginForm();
        },

    },

    methods: {
        initAppInfo: function() {
            myStore.clear();
            const query = qs.parse(window.location.search);
            let appId = query.appId;
            if (! appId) appId = 'MTWEB'; // just for developing

            this.action = query.action || 'login';
            if (this.action === 'bind') {
                document.title = '学校统一身份认证';
            }
            if (this.action === 'confirm') {
                document.title = '个人信息确认';
            }

            const envConfig = allConfigs[process.env.NODE_ENV];
            if (! envConfig || ! (appId in envConfig.apps)) {
                console.error('无法找到对应的应用配置');
                if (process.env.NODE_ENV === 'development') {
                    let url = 'https://dev.mbook.cc/mosoteach/index.php';
                    window.location.href = url;
                }

                if (process.env.NODE_ENV === 'production') {
                    let url = 'https://www.mosoteach.cn/web/index.php';
                    window.location.href = url;
                }
                return false;
            }
            
            this.appInfo = envConfig.apps[appId];
            this.appInfo.id = appId;

            const coreapiToken = query.token;
            if (coreapiToken) {
                this.coreapiToken = coreapiToken;
                this.doCoreapiTokenLogin();
            } else {
                this.accessId = query.accessId || null;
                this.gotoSchoolList();
            }

            const returnParam = query.returnParam;
            if (returnParam) {
                this.returnParam = returnParam;
                this.state = {
                    product: '',
                    action: 'login',
                    appId: 'MTWEB',
                    returnParam: 'home',
                }
            }

            return true;
        },

        showError: function(msg, type) {
            if (type === "MOSOTEACH") {
                this.$alert(msg, '错误', {
                    confirmButtonText: '确定',
                    type: 'error',
                    callback: action => {
                        if (this.state.product === 'PORTAL') {
                            this.$axios.request({
                                method: 'POST',
                                url: `/schools/create-portal-token`,
                                data: {
                                    accessId: this.$route.query.acsId ? this.$route.query.acsId : this.school.accessId,
                                }
                            }).then(resp => {
                                const data = resp.data;
                                // console.log(data);
                                if (! data.status) {
                                    this.showPortalFail(resp);
                                    return;
                                }
                                
                                if (process.env.NODE_ENV === 'development') {
                                    let url = `https://${data.site}.mbook.cc/`;
                                    window.location.href = url;
                                }

                                if (process.env.NODE_ENV === 'production') {
                                    let url = `https://${data.site}.mosoteach.cn/`;
                                    window.location.href = url;
                                }

                            }).catch(err => {
                                this.showError(err);
                            });
                        } else {
                            if (process.env.NODE_ENV === 'development') {
                                let url = 'https://dev.mbook.cc/mosoteach/index.php';
                                window.location.href = url;
                            }
    
                            if (process.env.NODE_ENV === 'production') {
                                let url = 'https://www.mosoteach.cn/web/index.php';
                                window.location.href = url;
                            }
                        }
                    }
                });
            } else {
                this.$alert(msg, {
                    title: '错误',
                    type: 'error',
                }).then(() => {
                    if (this.loading) {
                        this.loading = false;
                    }
                });
            }
        },

        showFail: function(resp, type) {
            const data = resp.data;
            const code = data.errorCode;
            let msg = null;
            if (code === 'VALIDATION_FAILED') {
                const errors = data.errors;
                if (errors) {
                    msg = Object.keys(errors).map(k => errors[k]).join('；');
                } else {
                    msg = data.errorMessage || '验证失败';
                }
            } else {
                msg = resp.data.errorMessage;
            }

            if (type === "MOSOTEACH") {
                this.$alert(msg, '错误', {
                    confirmButtonText: '确定',
                    type: 'error',
                    callback: action => {
                        if (this.state.product === 'PORTAL') {
                            this.$axios.request({
                                method: 'POST',
                                url: `/schools/create-portal-token`,
                                data: {
                                    accessId: this.$route.query.acsId ? this.$route.query.acsId : this.school.accessId,
                                }
                            }).then(resp => {
                                const data = resp.data;
                                // console.log(data);
                                if (! data.status) {
                                    this.showPortalFail(resp);
                                    return;
                                }
                                
                                if (process.env.NODE_ENV === 'development') {
                                    let url = `https://${data.site}.mbook.cc/`;
                                    window.location.href = url;
                                }

                                if (process.env.NODE_ENV === 'production') {
                                    let url = `https://${data.site}.mosoteach.cn/`;
                                    window.location.href = url;
                                }

                            }).catch(err => {
                                this.showError(err);
                            });
                        } else {
                            if (process.env.NODE_ENV === 'development') {
                                let url = 'https://dev.mbook.cc/mosoteach/index.php';
                                window.location.href = url;
                            }
    
                            if (process.env.NODE_ENV === 'production') {
                                let url = 'https://www.mosoteach.cn/web/index.php';
                                window.location.href = url;
                            }
                        }
                    }
                });
            } else {
                this.$alert(msg, {
                    title: '错误',
                    type: 'error',
                });
            }
            
        },

        gotoSchoolList: function() {
            if (!this.accessId) {
                this.currentScene = this.SCENES.SCHOOL_LIST;
            }

            if (! this.schoolListScene.dataLoaded) {
                this.loadSchools();
            }
        },

        goBackToSchoolList: function() {
            this.logo = '';
            this.schoolLoginScene.formValidated = false;
            this.schoolLoginScene.showDeptSelection = false;
            this.schoolLoginScene.form.departmentId = '';
            this.schoolLoginScene.form.sn = '';
            this.schoolLoginScene.form.password = '';
            this.schoolLoginScene.form.name = '';
            this.schoolLoginScene.form.idNumber = '';
            this.schoolLoginScene.showUserNameInput = false;
            this.schoolLoginScene.form.userName = '';
            // this.resetAliyunIc();
            this.gotoSchoolList();
        },

        loadSchools: function() {
            this.loading = true;
            this.$axios.request({
                method: 'GET',
                url: '/schools'
            }).then(resp => {
                const data = resp.data;
                this.schools = data.accounts.map(a => {
                    return {
                        oid: a.oid,
                        accessId: a.accessId,
                        schoolId: a.schoolId,
                        name: a.displaySchoolName,
                        sysName: a.displaySysName || '教务系统',
                        cnSpell: a.cnSpell,
                        level: a.level,
                    };
                });
                this.shownSchools = this.schools;
                this.schoolListScene.dataLoaded = true;
                this.loading = false;

                if (!this.accessId) return;

                let sIndex = this.schools.findIndex(s => s.accessId === this.accessId);
                if (sIndex >= 0) {
                    this.onSchoolClick(this.schools[sIndex]);
                } else {
                    this.showError('找不到对应学校');
                }
                
            }).catch(err => {
                this.loading = false;
                this.showError(err);
            });
        },

        onSchoolClick: function(row) {
            // console.log(row);

            this.$axios.request({
                method: 'GET',
                url: `/schools/${row.oid}/sso-config?product=MOSOTEACH`
            }).then(resp => {
                const data = resp.data;
                // console.log(data);
                if (data.ssoConfig.authType === 'THIRD_SSO') {
                    switch (row.accessId) {
                        case 'gench':
                            this.gotoGenchLogin(data);
                            break;
                        // 因为河南理工、宁波财经、四川水利的跳转方式和传参相同  所以可以调用同一个方法
                        case 'hpu':
                        case 'nbdhy':
                        case 'swcvc':
                        case 'hnshzy':
                        case 'kmyesf':
                            this.gotoSchoolLoginView(data);
                            break;
                        default:
                            break;
                    }
                    
                } else {
                    this.school.id = row.schoolId;
                    this.school.accessId = row.accessId;
                    this.school.oid = row.oid;
                    this.school.name = row.name;
                    this.school.sysName = row.sysName;
                    this.gotoSchoolLogin();
                }
            }).catch(err => {
                this.showError(err);
            });
        },

        gotoGenchLogin: function(data) {
            let token = myStore.getToken();
            let url = data.ssoConfig.goToUrl + `{
                            product: ${data.ssoConfig.product}
                            ${this.$route.query.action ? `,action: ${this.$route.query.action}` : ''}
                            ${this.$route.query.appId ? `,appId: ${this.$route.query.appId}` : ''}
                            ${this.$route.query.returnParam ? `,returnParam: ${this.$route.query.returnParam}` : ''}
                            ${token ? `,mttoken: ${token}` : ''}
                        }`;
            // console.log(url);
            window.location.href = url;
        },

        //河南理工、宁波财经、四川水利 跳转方式和拼接参数相同  公用一个方法
        gotoSchoolLoginView: function(data) {
            let token = myStore.getToken();
            let url = data.ssoConfig.goToUrl + `/${data.ssoConfig.product}/${this.$route.query.action}/${this.$route.query.appId}/${this.$route.query.returnParam}/${token ?  `${token}`: '' }`;
            console.log(url);
            window.location.href = url;
        },

        gotoSchoolLogin: function() {
            window.scrollTo(0, 0);
            this.currentScene = this.SCENES.SCHOOL_LOGIN;
            this.schoolLoginScene.form.userType = this.teachUser.userType;
            this.loadSsoConfig();
            // this.$nextTick(() => {
            //     this.initAwsc();
            // });
        },

        loadSsoConfig: function() {
            this.loading = true;
            this.$axios.request({
                method: 'GET',
                url: `/schools/${this.school.oid}/sso-config`
            }).then(resp => {
                const data = resp.data;
                this.logo = data.ssoConfig.teachLogoUrl || '';
                this.school.accessId = data.ssoConfig.accessId;
                Object.assign(this.school.ssoConfig, data.ssoConfig);
                if (!this.school.ssoConfig.teacherEnabled && !this.school.ssoConfig.studentEnabled) {
                    this.$alert('当前学校未开通统一身份认证，请联系管理员开通', {
                        title: '错误',
                        type: 'error',
                    }).then(() => {
                        if (this.loading) {
                            this.loading = false;
                        }
                    });
                }

                if (! (this.school.ssoConfig.teacherEnabled && this.school.ssoConfig.studentEnabled)) {
                    this.schoolLoginScene.form.userType = this.school.ssoConfig.teacherEnabled ? 'T' : 'S';
                }
                this.loading = false;
            }).catch(err => {
                this.loading = false;
                this.showError(err);
            });
        },

        initAwsc: function() {
            

            window.AWSC.use('ic', (state, module) => {
                window.ic = module.init({
                    // 应用类型标识。它和使用场景标识（scene字段）一起决定了智能验证的业务场景与后端对应使用的策略模型。您可以在人机验证控制台的配置管理页签找到对应的appkey字段值，请务必正确填写。
                    appkey: this.awscConfig.appkey,
                    // 使用场景标识。它和应用类型标识（appkey字段）一起决定了智能验证的业务场景与后端对应使用的策略模型。您可以在人机验证控制台的配置管理页签找到对应的scene值，请务必正确填写。
                    scene: this.awscConfig.scene,
                    // height: 40,
                    // 声明智能验证需要渲染的目标元素ID。
                    renderTo: 'aliyun-ic',
                    width: '100%',
                    fail_txt: '验证失败，请点击此按钮重新进行验证',
                    // 验证通过时会触发该回调参数。您可以在该回调参数中将会话ID（sessionId）、签名串（sig）、请求唯一标识（token）字段记录下来，随业务请求一同发送至您的服务端调用验签。
                    success: data => {
                        window.console && console.log(data.sessionId);
                        window.console && console.log(data.sig);
                        window.console && console.log(data.token);
                        this.awscResult.sessionId = data.sessionId;
                        this.awscResult.signature = data.sig;
                        this.awscResult.token = data.token;
                        this.aliyunIcOk = true;
                        // this.validateSchoolLoginForm();
                        this.doSchoolLogin();
                    },
                    // 验证失败时触发该回调参数
                    fail: (failCode) => {
                        window.console && console.log('failCode:', failCode);
                        this.aliyunIcOk = false;
                        this.validateSchoolLoginForm();
                    },
                    // 验证码加载异常时触发该回调参数
                    error: (errorCode) => {
                        window.console && console.log('errorCode:', errorCode);
                        this.aliyunIcOk = false;
                        this.validateSchoolLoginForm();
                        this.showError('智能验证组件验证失败，请稍后重试！');
                    }
                });
            });
        },

        resetAliyunIc: function() {
            this.awscResult.sessionId = null;
            this.awscResult.signature = null;
            this.awscResult.token = null;
            this.aliyunIcOk = false;
            window.ic.reset();
        },

        openAliyunIcDialog: function() {
            window.scrollTo(0, 0);
            this.dialogVisible = true;
            this.$nextTick(() => {
                this.initAwsc();
            });
        },

        closeAliyunIc: function() {
            this.dialogVisible = false;
            this.resetAliyunIc();
        },

        validateSchoolLoginForm: function() {
            const form = this.schoolLoginScene.form;
            const ssoConfig = this.school.ssoConfig;
            const scene = this.schoolLoginScene;

            if (form.sn.trim().length === 0) {
                scene.formValidated = false;
                return;
            }

            // if (! this.aliyunIcOk) {
            //     scene.formValidated = false;
            //     return;
            // }

            if (scene.showDeptSelection && !form.departmentId) {
                scene.formValidated = false;
                return;
            }

            if (scene.showUserNameInput && !form.userName) {
                scene.formValidated = false;
                return;       
            }

            if (ssoConfig.authType === 'SN+PWD') {
                if (form.password.trim().length === 0) {
                    scene.formValidated = false;
                    return;
                }
            } else if (ssoConfig.authType === 'SN+ID') {
                if (form.name.trim().length === 0) {
                    scene.formValidated = false;
                    return;
                }

                if (form.idNumber.trim().length === 0) {
                    scene.formValidated = false;
                    return;
                }
            }

            scene.formValidated = true;

        },

        doSchoolLogin: function() {
            const form = this.schoolLoginScene.form;
            // let teachDepartmentName = null;
            // if (form.departmentId) {
            //     let depts = this.departments.filter(d => d.id === form.departmentId);
            //     if (depts.length != 1) {
            //         this.showError('找不到院系了...');
            //         return;
            //     }
            //     teachDepartmentName = depts[0].name;
            // }

            this.loading = true;
            this.$axios.request({
                method: 'POST',
                url: `/schools/${this.school.oid}/login`,
                headers: {
                    'X-afs-session-id': this.awscResult.sessionId,
                    'X-afs-token': this.awscResult.token,
                    'X-afs-sig': this.awscResult.signature,
                    'X-afs-scene': this.awscConfig.scene
                },
                data: {
                    accountName: form.sn,
                    fullName: form.name,
                    password: form.password,
                    idNumber: form.idNumber,
                    userType: form.userType,
                    // teachDepartmentName: teachDepartmentName
                }
            }).then(resp => {
                this.loading = false;
                const data = resp.data;
                this.closeAliyunIc();//关闭人机验证弹窗
                if (! data.status) {
                    this.showFail(resp);
                    // this.resetAliyunIc();
                    return;
                }
                if (data.token) {
                    myStore.saveToken(data.token);
                }

                if (data.schoolUser) {
                    const u = data.schoolUser;
                    this.user = data.schoolUser;
                    this.schoolUser.sn = u.userNo;
                    this.schoolUser.name = u.userName;
                    this.schoolUser.userType = u.userType;
                    this.schoolUser.departmentName = u.teachDepartmentName;
                    this.schoolLoginScene.form.departmentId = u.teachDepartmentId;
                    this.schoolLoginScene.form.teachMajorSn = u.teachMajorSn;
                    this.schoolLoginScene.form.teachAdminClazzSn = u.teachAdminClazzSn;
                    this.schoolLoginScene.form.enrollYear = u.admissionYear ? u.admissionYear : -1;
                    this.schoolLoginScene.form.userName = u.userName;
                }
                const nextStep = data.nextStep;
                this.nextStep = data.nextStep;
                // console.log(nextStep);
                switch (nextStep) {
                    case 'RETURN_TO_APP':
                        this.gotoResult();
                        break;
                    case 'CHOOSE_DEPT':
                        // this.showError('你的教务资料不是教学院系，请确定你的教学院系');
                        // this.loadDepartments();
                        // this.resetAliyunIc();
                        // this.schoolLoginScene.formValidated = false;
                        // if (data.schoolUser.admissionYear < 2012 && data.schoolUser.userType === 'S') {
                        if (data.schoolUser.userType === 'S') {
                            this.schoolLoginScene.showDeptSelection = true;
                            this.schoolLoginScene.showMajorSelection = true;
                            this.schoolLoginScene.showAdminClazzSelection = true;
                            this.schoolLoginScene.showEnrollYearSelection = true;
                            // this.getMajors();
                            // this.getAdminClazzes();
                        }
                        this.schoolLoginScene.showUserNameInput = true;
                        this.loadDepartments();
                        this.showPhoneValidate = false;
                        this.gotoMosoinkLogin();
                        break;
                    case 'LOGIN_TO_MOSOINK':
                        // if (!data.schoolUser.teachDepartmentId && !data.schoolUser.teachDepartmentName) {
                        //     this.loadDepartments();
                        // }
                        // if (data.schoolUser.admissionYear < 2012 && data.schoolUser.userType === 'S') {
                        //     this.schoolLoginScene.showEnrollYearSelection = true;
                        // }
                        this.gotoMosoinkLogin();
                        break;
                    case 'BIND':
                        this.teachUser.phoneNumber = data.schoolUser.phoneNumber;
                        this.schoolLoginScene.snLabel = data.schoolUser.userType === 'T' ? '教师' : '学生';
                        this.schoolUser.sn = data.schoolUser.userName;
                        this.gotoConfirmBind();
                        break;
                }
            }).catch(err => {
                this.loading = false;
                this.showError(err);
            });
        },

        doCoreapiTokenLogin: function() {
            this.loading = true;
            this.$axios.request({
                method: 'POST',
                url: '/users/login-by-coreapi-token',
                data: {
                    token: this.coreapiToken
                }
            }).then(resp => {
                this.loading = false;
                const data = resp.data;
                if (! data.status) {
                    this.showFail(resp);
                    return;
                }

                const token = data.token;
                if (token) {
                    myStore.saveToken(token);
                }
                // console.log(data);
                const user = data.user;
                this.teachUser.id = user.id;
                this.teachUser.phoneNumber = user.phoneNumber;
                this.teachUser.name = user.name;
                this.teachUser.userType = user.userType;

                const school = data.school;
                this.school.id = school.id;
                this.school.name = school.name;
                this.school.sysName = school.displaySysName || '教务系统';
                this.school.oid = school.oid;

                this.getSsoConfig(school);
                
            }).catch(err => {
                this.loading = false;
                this.showError(err);
            });
        },

        getSsoConfig: function(school) {
            this.$axios.request({
                method: 'GET',
                url: `/schools/${school.oid}/sso-config?product=MOSOTEACH`
            }).then(resp => {
                const data = resp.data;
                // console.log(data);
                if (data.ssoConfig.authType === 'THIRD_SSO') {
                    switch (data.ssoConfig.accessId) {
                        case 'gench':
                            this.gotoGenchLogin(data);
                            break;
                        // 因为河南理工、宁波财经、四川水利的跳转方式和传参相同  所以可以调用同一个方法
                        case 'hpu':
                        case 'nbdhy':
                        case 'swcvc':
                        case 'hnshzy':
                        case 'kmyesf':
                            this.gotoSchoolLoginView(data);
                            break;
                        default:
                            console.error('无效的accessId');
                            break;
                    }
                    // let url = data.ssoConfig.goToUrl + `{
                    //                 product: ${data.ssoConfig.product}
                    //                 ${this.$route.query.action ? `,action: ${this.$route.query.action}` : ''}
                    //                 ${this.$route.query.appId ? `,appId: ${this.$route.query.appId}` : ''}
                    //                 ${this.$route.query.returnParam ? `,returnParam: ${this.$route.query.returnParam}` : ''}
                    //                 ${token ? `,mttoken: ${token}` : ''}
                    //             }`;
                    // console.log(url);
                    // window.location.href = url;
                } else {
                    this.logo = data.ssoConfig.teachLogoUrl || '';
                    this.gotoSchoolLogin();
                }
            }).catch(err => {
                this.showError(err);
            });
        },

        loadDepartments: function(oid) {
            this.loading = true;
            this.$axios.request({
                method: 'GET',
                url: `/schools/${oid ? oid : this.school.oid}/departments`
            }).then(resp => {
                this.loading = false;
                const data = resp.data;
                if (! data.status) {
                    this.showFail(resp);
                    return;
                }
                this.departments = data.departments;
                this.schoolLoginScene.showDeptSelection = true;
                this.getMajors(oid);
            }).catch(err => {
                this.loading = false;
                this.showError(err);
            });
        },

        gotoMosoinkLogin: function() {
            window.scrollTo(0, 0);
            this.currentScene = this.SCENES.MOSOINK_LOGIN;
        },

        validateMosoinkLoginForm: function() {
            const scene = this.mosoinkLoginScene;
            const form = this.mosoinkLoginScene.form;
            let userType = this.$route.query.schoolUser ? this.$route.query.schoolUser.userType : this.user.userType;

            if (/^1\d{10}$/.test(form.phoneNumber.trim()) && scene.timerId === 0) {
                scene.getSmsCodeButtonDisabled = false;
            } else {
                scene.getSmsCodeButtonDisabled = true;
            }

            if (/^1\d{10}$/.test(form.phoneNumber.trim()) && /^\d{4}$/.test(form.smsCode.trim())) {
                scene.loginButtonDisabled = false;
            } else {
                scene.loginButtonDisabled = true;
            }

            if (!this.showPhoneValidate) {
                scene.loginButtonDisabled = false;
            }

            if (this.authType === 'THIRD_SSO') {
                if (userType === 'S') {
                    if (this.schoolLoginScene.form.departmentId && this.schoolLoginScene.form.majorId && this.schoolLoginScene.form.adminClazzId && this.schoolLoginScene.form.enrollYear !== -1) {
                        scene.loginFillButtonDisabled = false;
                    } else {
                        scene.loginFillButtonDisabled = true;
                    }
                } else {
                    if (this.schoolLoginScene.form.departmentId) {
                        scene.loginFillButtonDisabled = false;
                    } else {
                        scene.loginFillButtonDisabled = true;
                    }
                }
            }
            if (this.authType !== 'THIRD_SSO') {
                if (userType === 'S') {
                    if (this.schoolLoginScene.form.departmentId && this.schoolLoginScene.form.enrollYear !== -1) {
                        scene.loginFillButtonDisabled = false;
                    } else {
                        scene.loginFillButtonDisabled = true;
                    }
                } else {
                    if (this.schoolLoginScene.form.departmentId) {
                        scene.loginFillButtonDisabled = false;
                    } else {
                        scene.loginFillButtonDisabled = true;
                    }
                }
            }
        },

        getMajors: function(oid) {
            if (!this.schoolLoginScene.form.departmentId) {
                this.majors = [];
                return;
            }
            this.$axios.request({
                method: 'GET',
                url: `/schools/${oid ? oid : this.school.oid}/dept/${this.schoolLoginScene.form.departmentId}/majors`,
            }).then(resp => {
                let { data } = resp;
                this.majors = data.result;
                // this.schoolLoginScene.showMajorSelection = true;
                this.schoolLoginScene.form.majorId = (this.majors && this.majors.filter(item => item.sn === this.schoolLoginScene.form.teachMajorSn).map(obj => obj.oid)[0]) || '';
                this.getAdminClazzes(oid);
            }).catch(err => {
                console.error(err);
                this.majors = [];
            }).finally(() => {});
        },

        getAdminClazzes: function(oid) {
            if (!this.schoolLoginScene.form.majorId) {
                this.adminClazzes = [];
                return;
            }
            this.$axios.request({
                method: 'GET',
                url: `/schools/${oid ? oid : this.school.oid}/dept/${this.schoolLoginScene.form.departmentId}/major/${this.schoolLoginScene.form.majorId}/adminClazzes`,
            }).then(resp => {
                let { data } = resp;
                this.adminClazzes = data.result;
                // this.schoolLoginScene.showAdminClazzSelection = true;
                this.schoolLoginScene.form.adminClazzId = (this.adminClazzes && this.adminClazzes.filter(item => item.sn === this.schoolLoginScene.form.teachAdminClazzSn).map(obj => obj.oid)[0]) || '';
            }).catch(err => {
                console.error(err);
                this.adminClazzes = [];
            }).finally(() => {});
        },

        getSmsCode: function() {
            this.loading = true;
            this.$axios.request({
                method: 'POST',
                url: '/users/sms-codes',
                data: {
                    phoneNumber: this.mosoinkLoginScene.form.phoneNumber.trim(),
                    accessId: this.$route.query.acsId ? this.$route.query.acsId : this.school.accessId,
                    type: 'BSA'
                }
            }).then(resp => {
                this.loading = false;
                const data = resp.data;
                if (! data.status) {
                    this.showFail(resp);
                    return;
                }
                this.mosoinkLoginScene.getSmsCodeButtonDisabled = true;  //开始倒计时，禁用倒计时按钮
                this.startSmsCodeTimer();
            }).catch(err => {
                this.loading = false;
                this.showError(err);
            });
        },

        startSmsCodeTimer: function() {
            const scene = this.mosoinkLoginScene;
            const n = 60;
            const startMs = Date.now();
            scene.phoneNumberInputDisabled = true;
            scene.timerId = setInterval(() => {
                const nowMs = Date.now();
                const delta = Math.floor((nowMs - startMs) / 1000);
                if (delta > n) {
                    this.stopSmsCodeTimer();
                    return;
                }

                scene.getSmsCodeButtonLabel = `${n - delta} 秒后重新获取`;
            }, 100);
        },

        stopSmsCodeTimer: function() {
            this.mosoinkLoginScene.getSmsCodeButtonDisabled = false; //倒计时结束后，复原获取验证码按钮
            const scene = this.mosoinkLoginScene;
            clearInterval(scene.timerId);
            scene.timerId = 0;
            scene.getSmsCodeButtonLabel = '获取验证码';
            scene.phoneNumberInputDisabled = false;
        },

        handleChange: function(val) {
            // console.log(val);
            let obj = null;
            obj = this.departments.find((item) => {
                return item.id === val;
            });
            this.schoolLoginScene.form.departmentName = obj.name;
        },

        doFill: function() {
            this.$axios.request({
                method: 'POST',
                url: '/users/user-info',
                data: {
                    schoolUser: this.$route.query.schoolUser ? this.$route.query.schoolUser : this.user,
                    accessId: this.$route.query.acsId ? this.$route.query.acsId : this.school.accessId,
                    deptName: (this.departments && this.departments.filter(item => item.id === this.schoolLoginScene.form.departmentId).map(obj => obj.name)[0]) || '',
                    deptId: this.schoolLoginScene.form.departmentId,
                    majorSn: (this.majors && this.majors.filter(item => item.oid === this.schoolLoginScene.form.majorId).map(obj => obj.sn)[0]) || '',
                    majorName: (this.majors && this.majors.filter(item => item.oid === this.schoolLoginScene.form.majorId).map(obj => obj.name)[0]) || '',
                    adminClazzSn: (this.adminClazzes && this.adminClazzes.filter(item => item.oid === this.schoolLoginScene.form.adminClazzId).map(obj => obj.sn)[0]) || '',
                    adminClazzName: (this.adminClazzes && this.adminClazzes.filter(item => item.oid === this.schoolLoginScene.form.adminClazzId).map(obj => obj.name)[0]) || '',
                    admissionYear: this.schoolLoginScene.form.enrollYear,
                    userName: this.schoolLoginScene.form.userName,
                }
            }).then(resp => {
                this.loading = false;
                const data = resp.data;
                // console.log(data);
                if (! data.status) {
                    this.showFail(resp);
                    return;
                }
                this.teachUser.phoneNumber = data.schoolUser.phoneNumber;
                this.schoolLoginScene.snLabel = data.schoolUser.userType === 'T' ? '教师' : '学生';
                this.schoolUser.sn = data.schoolUser.userName;
                this.gotoConfirmBind();
            }).catch(err => {
                this.loading = false;
                this.showError(err);
            });
        },

        doMosoinkLogin: function() {
            // console.log(this.nextStep);
            if (this.nextStep === 'CHOOSE_DEPT') {
                // if (this.$route.query.schoolUser && this.$route.query.schoolUser.admissionYear < 2012 && this.$route.query.schoolUser.userType === 'S') {
                if (this.$route.query.schoolUser && this.$route.query.schoolUser.userType === 'S') {
                    this.schoolLoginScene.showDeptSelection = true;
                    this.schoolLoginScene.showMajorSelection = true;
                    this.schoolLoginScene.showAdminClazzSelection = true;
                    this.schoolLoginScene.showEnrollYearSelection = true;
                    // this.getMajors();
                    // this.getAdminClazzes();
                    this.schoolLoginScene.form.teachMajorSn = this.$route.query.schoolUser.teachMajorSn || '';
                    this.schoolLoginScene.form.teachAdminClazzSn = this.$route.query.schoolUser.teachAdminClazzSn || '';
                    this.schoolLoginScene.form.enrollYear = this.$route.query.schoolUser.admissionYear ? this.$route.query.schoolUser.admissionYear : -1;
                }
                if (this.schoolLoginScene.form.userType === 'S') {
                    this.schoolLoginScene.showEnrollYearSelection = true;
                }
                this.schoolLoginScene.showUserNameInput = true;
                this.schoolLoginScene.form.userName = this.$route.query.schoolUser.userName || '';
                this.loadDepartments();
                this.schoolLoginScene.form.departmentId = this.$route.query.schoolUser.teachDepartmentId;
            }
            if (this.nextStep === 'LOGIN_TO_MOSOINK') {
                // if (this.$route.query.schoolUser && this.$route.query.schoolUser.admissionYear < 2012 && this.$route.query.schoolUser.userType === 'S') {
                //     this.schoolLoginScene.showEnrollYearSelection = true;
                // }
                const scene = this.mosoinkLoginScene;
                const form = scene.form;
                this.$axios.request({
                    method: 'POST',
                    url: '/users/sms-codes/validate',
                    data: {
                        phoneNumber: form.phoneNumber.trim(),
                        code: form.smsCode.trim(),
                        accessId: this.$route.query.acsId ? this.$route.query.acsId : this.school.accessId,
                        // deptName: this.schoolLoginScene.form.departmentName,
                        // deptId: this.schoolLoginScene.form.departmentId,
                        // admissionYear: this.schoolLoginScene.form.enrollYear,
                        type: 'BSA'
                    }
                }).then(resp => {
                    this.loading = false;
                    const data = resp.data;
                    if (! data.status) {
                        this.showFail(resp);
                        return;
                    }
                    const user = data.user;
                    this.teachUser.id = user.id;
                    this.teachUser.name = user.name;
                    this.teachUser.phoneNumber = user.phoneNumber;
                    this.schoolLoginScene.snLabel = user.schoolUser.userType === 'T' ? '教师' : '学生';
                    this.schoolUser.sn = user.name;

                    this.showPhoneValidate = false;
                    if (this.$route.query.schoolUser && this.$route.query.schoolUser.userType === 'S') {
                        this.schoolLoginScene.showDeptSelection = true;
                        this.schoolLoginScene.showMajorSelection = true;
                        this.schoolLoginScene.showAdminClazzSelection = true;
                        this.schoolLoginScene.showEnrollYearSelection = true;
                        // this.getMajors();
                        // this.getAdminClazzes();
                        this.schoolLoginScene.form.teachMajorSn = user.schoolUser.teachMajorSn || '';
                        this.schoolLoginScene.form.teachAdminClazzSn = user.schoolUser.teachAdminClazzSn || '';
                        this.schoolLoginScene.form.enrollYear = user.schoolUser.admissionYear ? user.schoolUser.admissionYear : -1;
                    }
                    if (user.schoolUser.userType === 'S') {
                        this.schoolLoginScene.showEnrollYearSelection = true;
                        this.schoolLoginScene.form.enrollYear = user.schoolUser.admissionYear ? user.schoolUser.admissionYear : -1;
                    }
                    this.schoolLoginScene.showUserNameInput = true;
                    this.schoolLoginScene.form.userName = user.schoolUser.userName || '';
                    this.loadDepartments();
                    this.schoolLoginScene.form.departmentId = user.schoolUser.teachDepartmentId;
    
                    // this.gotoConfirmBind();
                }).catch(err => {
                    this.loading = false;
                    this.showError(err);
                });
            }
        },

        gotoConfirmBind: function() {
            window.scrollTo(0, 0);
            this.currentScene = this.SCENES.CONFIRM_BIND;
        },

        bind: function() {
            this.loading = true;
            this.$axios.request({
                method: 'POST',
                url: '/users/bind',
                params: { oid: this.school.oid ? this.school.oid : this.$route.query.accountOid },
                data: {}
            }).then(resp => {
                this.loading = false;
                const data = resp.data;
                // console.log(data);
                if (! data.status) {
                    this.showFail(resp, 'MOSOTEACH');
                    return;
                }
                if (this.state.product === 'PORTAL') {
                    this.gotoPortal();
                } else {
                    this.gotoResult();
                }
            }).catch(err => {
                this.loading = false;
                this.showError(err, 'MOSOTEACH');
            })
        },

        gotoResult: function() {
            window.scrollTo(0, 0);
            this.currentScene = this.SCENES.RESULT;
            // this.startReturnToAppTimer();
            this.returnToApp();
        },

        returnToApp: function() {
            const appInfo = this.appInfo;
            if (typeof appInfo.returnTo === 'string') {
                // this.loading = true;
                this.$axios.request({
                    method: 'POST',
                    url: '/users/create-coreapi-token',
                    data: {}
                }).then(resp => {
                    const data = resp.data;
                    if (! data.status) {
                        // this.loading = false;
                        window.console && console.error('获取coreapi-token失败', data);
                        this.showFail(resp);
                        return;
                    }
                    myStore.clear();
                    const coreapiToken = data.coreapiToken;
                    const url = `${appInfo.returnTo}?appId=${this.appInfo.id ? this.appInfo.id : this.state.appId}&token=${coreapiToken}${this.returnParam ? `&returnParam=${this.returnParam}` : (this.state.returnParam ? `&returnParam=${this.state.returnParam}` : '')}`;
                    window.console && console.log('返回跳转链接：', url);
                    window.location.href = url;
                }).catch(err => {
                    // this.loading = false;
                    window.console && console.error('获取coreapi-token异常', err);
                    this.showError(err);
                })
            } else if (typeof appInfo.returnTo === 'function') {

            } else {
                // something goes error
                window.console && window.console.error('返回失败');
            }
        },

        startReturnToAppTimer: function() {
            const scene = this.resultScene;
            const startMs = Date.now();
            const n = scene.count;
            scene.timerId = setInterval(() => {
                const nowMs = Date.now();
                const delta = Math.floor((nowMs - startMs) / 1000);
                if (delta > n) {
                    clearInterval(scene.timerId);
                    scene.timerId = 0;
                    this.returnToApp();
                    return;
                }
                scene.count = n - delta;
            }, 100);
        },

        gotoPortal: function() {
            this.$axios.request({
                method: 'POST',
                url: `/schools/create-portal-token`,
                data: {
                    accessId: this.$route.query.acsId ? this.$route.query.acsId : this.school.accessId,
                }
            }).then(resp => {
                const data = resp.data;
                // console.log(data);
                if (! data.status) {
                    this.showPortalFail(resp);
                    return;
                }
                
                if (process.env.NODE_ENV === 'development') {
                    let url = `https://${data.site}.mbook.cc/login-by-school-sso-token?token=${data.token}`;
                    window.location.href = url;
                }

                if (process.env.NODE_ENV === 'production') {
                    let url = `https://${data.site}.mosoteach.cn/login-by-school-sso-token?token=${data.token}`;
                    window.location.href = url;
                }

            }).catch(err => {
                this.showError(err);
            });
        },

        showPortalFail: function(resp) {
            const data = resp.data;
            const code = data.errorCode;
            let msg = null;
            if (code === 'VALIDATION_FAILED') {
                const errors = data.errors;
                if (errors) {
                    msg = Object.keys(errors).map(k => errors[k]).join('；');
                } else {
                    msg = data.errorMessage || '验证失败';
                }
            } else {
                msg = resp.data.errorMessage;
            }
            
            this.$alert(msg, '错误', {
                confirmButtonText: '确定',
                type: 'error',
                callback: action => {
                    this.toPortal();
                }
            });
        },

        toPortal: function() {
            let accessId = this.$route.query.acsId ? this.$route.query.acsId : this.school.accessId;
            this.$axios.request({
                method: 'GET',
                url: `schools/${accessId}/school-simple`,
            }).then(resp => {
                const data = resp.data;
                // console.log(data);
                if (process.env.NODE_ENV === 'development') {
                    let url = `https://${data.school.site}.mbook.cc`;
                    window.location.href = url;
                }

                if (process.env.NODE_ENV === 'production') {
                    let url = `https://${data.school.site}.mosoteach.cn`;
                    window.location.href = url;
                }

            }).catch(err => {
                this.showError(err);
            });
        },

        getSchoolConfig: function() {
            this.$axios.request({
                method: 'GET',
                url: `/schools/${this.school.oid}/sso-config`
            }).then(resp => {
                const data = resp.data;
                this.logo = data.ssoConfig.teachLogoUrl || '';
            }).catch(err => {
                this.showError(err);
            });
        }

    }
};
</script>

<style>

body {
    margin: 0;
    padding: 0;
    font-family: Avenir, Helvetica, Arial, 'PingFang SC', 'Noto Sans SC', '微软雅黑', sans-serif;
}

#container {
    font-family: Avenir, Helvetica, Arial, 'PingFang SC', 'Noto Sans SC', '微软雅黑', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}


.header-box {
    /* background: rgba(0, 0, 0, 0.4); */
    border-bottom: 1px solid #ddd;
}

.teach-logo {
    height: 80px;
    background-size: 169px 40px;
    /* background-image: url('./assets/logo.png'); */
    background-image: url('../assets/teach-logo.png');
    background-position: left 50%;
    background-repeat: no-repeat;
}

.logo-box {
    height: 80px;
    display: flex;
    flex-direction: row;
    align-items: center;
}

.header-right {
    display: flex;
    height: 80px;
    align-items: center;
    justify-content: flex-end;
}

.header-right a.blue,
.header-right a:link.blue,
.header-right a:visited.blue {
    display: inline-block;
    color: #0BD;
    text-decoration: none;
    line-height: 100%;
}

.header-right a:hover.blue,
.header-right a:active.blue {
    text-decoration: underline;
}

.header-right .v-line {
    border-left: 1px solid #CCC;
    margin-left: 10px;
    margin-right: 10px;
    width: 0;
    height: 1rem;
}

.el-select-dropdown.el-popper {
    position: absolute !important;
    max-width: 100%;
}

.el-dialog__body {
    padding: 30px 20px 60px 20px!important;
}
.el-dialog{
    border-radius: 8px!important; 
}
@media screen and (max-width: 768px){
    .aliyunIcDialog {
        margin-top: 60% !important;
        width: 80% !important;
    }
}
</style>
